module.exports = __webpack_public_path__ + "6b8f84b71b6ed83a6825e535d2ddc4f0.jpg";